export default "__VITE_ASSET__Dj1Ae0PS__"